import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import useRequest from "../../hooks/useRequest";
import { useSelector } from "react-redux";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import {
  Textarea,
  SubmitButton,
  Input,
  SubInput,
  SubTab
} from "../Form/Form";

const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();


  const { response, request } = useRequest();
  const { languages } = useSelector((state) => state.setting);

  const history = useHistory();

  useEffect(() => {
    document.title = "Add Faq - Calevalab";
  }, []);

  useEffect(() => {
    if (response) {
      toast.success("Faq has been added successfully.");
      history.push("/faq");
    }
  }, [response]);

  const onSubmit = (data) => {
    const defaultData                   = {};
    const langData                      = [];

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      if (languages[i].default) {
        defaultData.question = data?.["question-" + code];
        defaultData.answer = data?.["answer-" + code];
      }
      langData.push({ languageCode:code, question: data[`question-${code}`], answer: data[`answer-${code}`]});
    }
 
    request("POST", "faq", {...defaultData,langData:JSON.stringify(langData)});
   
  };

  const InputFields = [
    [
      {
        Component: Input,
        type: "text",
        label: "Question",
        name: "question",
        colClass: "col-lg-12",
        registerFields: {
          required: true,
        },
      },
    ],
    [
      {
        Component: Textarea,
        label: "Answer",
        name: "answer",
        colClass: "col-lg-12",
        registerFields: {
          required: true,
        },
      },
    ],
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Add Faq"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/faq", name: "Back To FAQs" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">
                    Add New Faq
                  </h3>

                  <form onSubmit={handleSubmit(onSubmit)}>

                  <div className="row"></div>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <>
                                <SubInput
                                  key={index}
                                  index={index}
                                  errors={errors}
                                  register={register}
                                  required={true}
                                  InputFields={InputFields}
                                  code={lang.code}
                                />
                              </>
                            ))}
                        </div>
                        <div className="row"></div>
                      </div>
                    </div>

                    <div className="row"></div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
